import { useState } from 'react';
import { IUser, Network } from '@kattana-io/common';
import Text from '../../../../atoms/Text';
import { formatAddress } from '../../../../helpers/formatters';
import Image from '../../../../atoms/Image';
import { AVATAR_PLACEHOLDER } from '../../../../helpers/constants';
import useWalletSelect from './useWalletSelect';
import NumberDisplay from '../../../../molecules/NumberDisplay';
import { onWalletScan } from '../../../../helpers/addressUtils';

import './styles.scss';

interface IAvailableWalletsProps {
  user: IUser | null;
  address: string;
  network: Network;
  balance: number;
  nativeToken: string;
}

const PreviousWallets = ({
  user,
  address,
  network,
  balance,
  nativeToken,
}: IAvailableWalletsProps) => {
  const [showWallets, setShowWallets] = useState(false);

  const previousWallets = useWalletSelect(
    address,
    balance,
    nativeToken,
    network.getTitle(),
    user?.img_url,
    user?.nickname
  );

  const showWalletsStyle = showWallets
    ? 'icon-chevron-down'
    : 'icon-chevron-top';
  return (
    <div className='previous_wallets select_wallet__appear_box'>
      <div
        className='previous_wallets__title'
        onClick={() => setShowWallets(!showWallets)}
      >
        <div className={`previous_wallets__title__icon ${showWalletsStyle}`} />
        <Text size={12} className='text--weight-600 text--grey-600'>
          Previously logged wallets
        </Text>
      </div>
      {showWallets && previousWallets.length > 0 && (
        <div className='previous_wallets__table'>
          {previousWallets.map((wallet, index) => (
            <div key={index} className='previous_wallets__table__item'>
              <Image
                size='l'
                src={wallet.logo || AVATAR_PLACEHOLDER}
                alt={`${wallet.nickname || wallet.address} logo`}
                className='previous_wallets__table__item__logo'
              />
              <div className='previous_wallets__table__item__description'>
                <Text size={12} className='text--grey-200 text--weight-600'>
                  {wallet.nickname}
                </Text>
                <Text
                  size={12}
                  className='text--navy-600'
                  onClick={() =>
                    onWalletScan(wallet.address, network.getSlug())
                  }
                >
                  {formatAddress(wallet.address)}
                </Text>
              </div>
              <div className='previous_wallets__table__item__balance'>
                <Text size={12} className='text--grey-200 text--weight-600'>
                  {wallet.chain}
                </Text>
                <NumberDisplay
                  value={wallet.amount}
                  endSymbol={` ${wallet.nativeToken}`}
                  textProps={{ size: 14, className: 'text--grey-400' }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PreviousWallets;
